module.exports = __webpack_public_path__ + "img/compensation-section-image01.37a2fccc.png";